import React from "react";
import Select from "react-select";

const MultiSelect = ({
  name,
  placeholder,
  data,
  disabled,
  defaultValueArr,
  multiSelectVal,
  setMultiSelectVal,
  locationName,
  multi,
}) => {

  let npRecord = [];

  return (
    <div style={{ width: '320px' }}>
      {locationName ? <Select
        value={null}
        name={name}
        closeMenuOnSelect={false}
        defaultValue={defaultValueArr}
        isMulti
        placeholder={placeholder}
        options={data && data[0].value !== "" ? data : npRecord}
        // options={options}
        className="basic-multi-select"
        classNamePrefix="select"
        isSearchable={false}
        isDisabled={disabled}
        noOptionsMessage={() => "No records"}
        isClearable={true}
        onChange={(data, index) => {
          if (data !== null) {
            setMultiSelectVal(data);
          }
        }}
      /> :
        <Select
          value={defaultValueArr?defaultValueArr :null}
          name={name}
          closeMenuOnSelect={false}
          defaultValue={defaultValueArr}
          isMulti
          placeholder={placeholder}
          options={data && data[0].value !== "" ? data : npRecord}
          className="basic-multi-select"
          classNamePrefix="select"
          isSearchable={true}
          isDisabled={disabled}
          noOptionsMessage={() => "No records"}
          isClearable={true}
          onChange={(data, index) => {
            if (data !== null) {
              setMultiSelectVal(data); 
            }else{
              setMultiSelectVal(data);
            }
          }}
        />}
    </div>
  );
};
export default MultiSelect;
